module.exports = __webpack_public_path__ + "img/logo_gnb.1ba0a6ba.png";